<template>
  <div :class="'mb-2 ' + classes.row">
    <b for="name" v-if="label" :class="classes.label"> {{ label }} </b>
    <div :class="classes.input">
      <input :type="typeInput" :placeholder="label" autocomplete="off" class="form-control" v-bind="$attrs"
        :value="modelValue" :readonly="props?.readonly" :disabled="props.disabled" @keypress="isNumber($event)"
        @input="$emit('update:modelValue', $event.target.value)" />
      <span class="text-danger" v-for="error in v?.$errors" :key="error.$uid">
        {{ error.$message }}
      </span>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed, defineProps, PropType } from "vue";

const props = defineProps({
  modelValue: {
    type: [String, Number, null] as PropType<string | number | null>,
    default: null,
  },
  label: { type: String },
  type: { type: String, default: 'text' },
  readonly: { type: Boolean, default: false },
  typeStyle: { type: String, default: "" },
  disabled: { type: Boolean, default: false },
  v: {
    type: Object,
  },
});
const typeInput = computed(() => {
  return props.type === 'password' ? 'password' : 'text';
})
const classes = computed(() => {
  switch (props.typeStyle) {
    case "product":
      return {
        name: "product",
        row: "row",
        label: "col-sm-3 col-form-label",
        input: "col-sm-9",
      };
      break;
    default:
      return { name: "profile", row: "", label: "form-label", input: "" };
      break;
  }
});
const isNumber = (event) => {
  if (props.type == "price") {
    const keyCode = event.keyCode ? event.keyCode : event.which;
    if ((keyCode < 48 || keyCode > 57) && keyCode !== 46) {
      event.preventDefault();
    }
  }
  if (props.type == "number") {
    const keyCode = event.keyCode ? event.keyCode : event.which;
    if ((keyCode < 48 || keyCode > 57)) {
      event.preventDefault();
    }
  }
};
</script>

<style scoped></style>
